function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,9A2,2,0,1,0,5,7,2,2,0,0,0,3,9ZM6,9A1,1,0,1,1,5,8,1,1,0,0,1,6,9Zm1.5,3h-5A2.5,2.5,0,0,0,0,14.5,1.5,1.5,0,0,0,1.5,16h7A1.5,1.5,0,0,0,10,14.5,2.5,2.5,0,0,0,7.5,12Zm1,3h-7a.5.5,0,0,1-.5-.5A1.5,1.5,0,0,1,2.5,13h5A1.5,1.5,0,0,1,9,14.5.5.5,0,0,1,8.5,15ZM16,.5v8a.5.5,0,0,1-.5.5H10v1h2.5a.5.5,0,0,1,0,1h-4a.5.5,0,0,1,0-1H9V9H8.5a.5.5,0,0,1,0-1H15V1H4V5.5a.5.5,0,0,1-1,0V.5A.5.5,0,0,1,3.5,0h12A.5.5,0,0,1,16,.5ZM6.5,6a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7l2-2a.48.48,0,0,1,.7,0L10.5,4.79l2.65-2.64a.49.49,0,0,1,.7.7l-3,3a.48.48,0,0,1-.7,0L8.5,4.21,6.85,5.85A.47.47,0,0,1,6.5,6Z"
})));

function SvgRum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRum);
export default __webpack_public_path__ + "static/media/RUM.04726aae.svg";
export { ForwardRef as ReactComponent };